import { useMemo } from 'react';
export const extractPermissionsFromManifest = (manifest) => {
    return Object.fromEntries(Object.entries(manifest.compatibility?.permissions ?? {})
        .filter(([_, value]) => !!value)
        .map(([id, value]) => (typeof value === 'object' ? [id, value] : [id, {}])));
};
export const extractRequiredPermissionsFromManifest = (manifest) => Object.entries(extractPermissionsFromManifest(manifest))
    .filter(([, { for_tools }]) => !for_tools)
    .map(([id]) => id);
export const useCometRequiredSystemPermissions = ({ cometState, }) => {
    return useMemo(() => {
        if (!cometState.installedDxts) {
            return [];
        }
        const allPermissions = cometState.installedDxts.flatMap(({ manifest }) => extractRequiredPermissionsFromManifest(manifest));
        return Array.from(new Set(allPermissions));
    }, [cometState.installedDxts]);
};
//# sourceMappingURL=useCometRequiredSystemPermissions.js.map